<template>
    <v-card
        class="ma-0 mb-3 pa-3 wrapper"
        :class="{ 'ml-1' : !$vuetify.rtl && !isMobile && !isTablet, 'ml-0': !$vuetify.rtl && isMobile || isTablet}"
    >
      <v-container class="pa-0 d-flex chart-row">
        <div class="flex-fill">
          <v-card-text class="pa-0 text-h4">
              {{ $t('hello') }} {{ $store.state.fullname }} {{ $t('dear') }}
              <br />
              {{ $t('welcome') }} 👋
          </v-card-text>
          <v-container
            class="pa-0 mt-10 weather-wrapper position-relative mx-0 mb-0"
            :style="{ 'width' : $store.state.isMenuExpanded ? '210px' : '250px'}"
          >
              <v-card
                class="ma-0 weather d-flex align-center gap-2 position-relative"
              >
                  <v-container class="pa-1">
                      <v-card-text class="pa-0 text-caption" :class="{ 'text-end' : !$vuetify.rtl }">{{ hour }} {{ $t('tehran') }}</v-card-text>
                      <v-card-text class="pa-0 text-caption" :class="{ 'text-end' : !$vuetify.rtl }">{{ today }}</v-card-text>
                  </v-container>
              </v-card>
              <img
                  src="@/assets/dashboard/namad.png"
                  :class="[$store.state.isMenuExpanded ? 'weather-img-exp' : 'weather-img']"
              />
          </v-container>
        </div>
        <div class="flex-fill">
          <v-container
            class="pa-0 d-flex mr-2"
            :class="{ 'gap-3': !$vuetify.rtl }"
          >
              <div>
                  <div class="d-flex align-center gap-2">
                      <v-chip
                          label
                          class="sales-label"
                      >
                          <span>
                              <svg width="12" height="12" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.49692 1.75C8.298 1.75 8.10724 1.67098 7.96659 1.53033C7.82593 1.38968 7.74692 1.19891 7.74692 1C7.74692 0.801088 7.82593 0.610323 7.96659 0.46967C8.10724 0.329018 8.298 0.25 8.49692 0.25H10.9969C11.1958 0.25 11.3866 0.329018 11.5272 0.46967C11.6679 0.610323 11.7469 0.801088 11.7469 1V3.5C11.7469 3.69891 11.6679 3.88968 11.5272 4.03033C11.3866 4.17098 11.1958 4.25 10.9969 4.25C10.798 4.25 10.6072 4.17098 10.4666 4.03033C10.3259 3.88968 10.2469 3.69891 10.2469 3.5V2.81L8.23392 4.823C7.90576 5.15092 7.46083 5.33513 6.99692 5.33513C6.533 5.33513 6.08807 5.15092 5.75992 4.823L4.17392 3.237C4.15069 3.21372 4.12311 3.19525 4.09273 3.18264C4.06236 3.17004 4.0298 3.16355 3.99692 3.16355C3.96403 3.16355 3.93147 3.17004 3.9011 3.18264C3.87073 3.19525 3.84314 3.21372 3.81992 3.237L1.52692 5.53C1.38474 5.66248 1.1967 5.7346 1.00239 5.73118C0.808093 5.72775 0.622708 5.64903 0.485295 5.51162C0.347882 5.37421 0.26917 5.18882 0.265742 4.99452C0.262314 4.80022 0.334437 4.61217 0.466917 4.47L2.75992 2.177C3.08807 1.84908 3.533 1.66487 3.99692 1.66487C4.46083 1.66487 4.90576 1.84908 5.23392 2.177L6.81992 3.763C6.84314 3.78628 6.87073 3.80475 6.9011 3.81736C6.93147 3.82996 6.96403 3.83645 6.99692 3.83645C7.0298 3.83645 7.06236 3.82996 7.09273 3.81736C7.12311 3.80475 7.15069 3.78628 7.17392 3.763L9.18592 1.75H8.49692Z" fill="#fff"/>
                              </svg>
                          </span>
                      </v-chip>
                      <v-card-text
                          class="pa-0"
                          :class="[$store.state.isMenuExpanded ? 'text-caption' : 'text-body-2']"
                      >
                          {{ $t('total-sales') }}
                      </v-card-text>
                  </div>
                  <v-select
                      :items="items"
                      :label="$t('date')"
                      dense
                      outlined
                      append-icon="mdi-chevron-down"
                      class="mt-4"
                      :class="{ 'dltr' : !$vuetify.rtl}"
                      item-text="name"
                      item-value="value"
                      v-model="selectedSalesDate"
                      @change="selectDate(selectedSalesDate, 'sell')"
                      style="width: 130px;"
                      :style="{ 'direction' : !$vuetify.rtl ? 'rtl' : ''}"
                  >
                  </v-select>
                  <v-card-text
                    v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview') && $store.state.admin == 'active'"
                    class="pa-0 mt-12 text-body-1"
                  >
                  {{ $numberFormat(sumOfSells) }} {{ $store.state.currency.name }}
                  </v-card-text>
              </div>
              <div
                v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview') && $store.state.admin == 'active'"
                class="d-flex align-center justify-center"
              >
                  <apexchart
                    v-if="sellList != null && sellList != undefined && sellList.length > 0"
                    type="line"
                    :options="lineChartOptions"
                    :series="lineChartSeries"
                    :width="$store.state.isMenuExpanded || isMobile ? '250' : '300'"
                    height="160"
                  />
                  <div
                    class="mr-10"
                    v-if="sellList != null && sellList != undefined && sellList.length == 0 && !loading"
                  >
                    <div class="d-flex justify-center align-center">
                      <img src="@/assets/dashboard/no-data(1).png" style="width: 100px;" />
                    </div>
                    <div class="d-flex justify-center align-center mt-5">
                      <v-card-text class="pa-0 text-caption">
                        {{ $t('there is no enough information for showing.') }}
                      </v-card-text>
                    </div>
                  </div>
                  <v-progress-circular
                    v-if="loading"
                    :width="3"
                    color="blue"
                    class="mr-5"
                    indeterminate
                  />
              </div>
              <div v-else>
                <div class="mr-10">
                    <div class="d-flex justify-center align-center">
                      <img src="@/assets/dashboard/not-access(1).png" style="width: 100px;" />
                    </div>
                    <div class="d-flex justify-center align-center mt-5">
                      <v-card-text class="pa-0 text-caption">
                        {{ $t("you don't have access to this information") }}
                      </v-card-text>
                    </div>
                  </div>
              </div>
          </v-container>
        </div>
        <div class="flex-fill">
          <v-container
            class="pa-0 d-flex flex-column"
            :style="{ 'gap' : $store.getters.getpermission && $store.getters.getpermission.includes('overview') && $store.state.admin == 'active' ? '2.5rem' : '1rem' }"
          >
              <div
                class="d-flex justify-space-between"
              >
                <div class="d-flex align-center gap-1">
                  <v-chip
                      label
                      class="recieve-label"
                  >
                      <span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5" d="M3.172 7.17225C4.015 6.32825 5.23 6.09225 7.252 6.02625L8.752 6.00225C9.144 6.00025 9.56 5.99958 10 6.00025H14C14.4413 6.00025 14.8573 6.00092 15.248 6.00225L16.748 6.02625C18.77 6.09225 19.985 6.32825 20.828 7.17225C22 8.34325 22 10.2292 22 14.0002C22 17.7712 22 19.6572 20.828 20.8282C19.656 21.9992 17.771 22.0002 14 22.0002H10C6.229 22.0002 4.343 22.0002 3.172 20.8282C2.001 19.6562 2 17.7712 2 14.0002C2 10.2292 2 8.34325 3.172 7.17225Z" fill="#FCFCFC"/>
                        <path d="M12.7519 10C12.7519 9.80109 12.6729 9.61032 12.5322 9.46967C12.3916 9.32902 12.2008 9.25 12.0019 9.25C11.803 9.25 11.6122 9.32902 11.4716 9.46967C11.3309 9.61032 11.2519 9.80109 11.2519 10V10.01C10.1629 10.284 9.25191 11.143 9.25191 12.333C9.25191 13.79 10.6169 14.75 12.0019 14.75C12.8259 14.75 13.2519 15.283 13.2519 15.667C13.2519 16.051 12.8259 16.583 12.0019 16.583C11.1779 16.583 10.7519 16.051 10.7519 15.667C10.7519 15.4681 10.6729 15.2773 10.5322 15.1367C10.3916 14.996 10.2008 14.917 10.0019 14.917C9.80299 14.917 9.61223 14.996 9.47158 15.1367C9.33092 15.2773 9.25191 15.4681 9.25191 15.667C9.25191 16.857 10.1629 17.715 11.2519 17.99V18C11.2519 18.1989 11.3309 18.3897 11.4716 18.5303C11.6122 18.671 11.803 18.75 12.0019 18.75C12.2008 18.75 12.3916 18.671 12.5322 18.5303C12.6729 18.3897 12.7519 18.1989 12.7519 18V17.99C13.8409 17.716 14.7519 16.857 14.7519 15.667C14.7519 14.21 13.3869 13.25 12.0019 13.25C11.1779 13.25 10.7519 12.717 10.7519 12.333C10.7519 11.949 11.1779 11.417 12.0019 11.417C12.8259 11.417 13.2519 11.949 13.2519 12.333C13.2519 12.5319 13.3309 12.7227 13.4716 12.8633C13.6122 13.004 13.803 13.083 14.0019 13.083C14.2008 13.083 14.3916 13.004 14.5322 12.8633C14.6729 12.7227 14.7519 12.5319 14.7519 12.333C14.7519 11.143 13.8409 10.284 12.7519 10.01V10ZM12.0539 1.25H11.9499C11.0519 1.25 10.3019 1.25 9.70791 1.33C9.07991 1.414 8.51291 1.6 8.05791 2.055C7.60191 2.511 7.41591 3.078 7.33191 3.705C7.27491 4.132 7.25891 5.151 7.25391 6.025L8.75391 6.002C8.75891 5.155 8.77391 4.244 8.81891 3.905C8.88091 3.444 8.98791 3.246 9.11891 3.116C9.24991 2.986 9.44591 2.879 9.90791 2.816C10.3909 2.752 11.0379 2.75 12.0019 2.75C12.9659 2.75 13.6139 2.752 14.0969 2.817C14.5579 2.879 14.7559 2.986 14.8859 3.117C15.0159 3.248 15.1239 3.444 15.1859 3.905C15.2309 4.245 15.2459 5.155 15.2499 6.002L16.7499 6.026C16.7459 5.151 16.7299 4.132 16.6719 3.706C16.5879 3.078 16.4019 2.511 15.9469 2.056C15.4909 1.6 14.9239 1.414 14.2969 1.33C13.7019 1.25 12.9529 1.25 12.0539 1.25Z" fill="#FCFCFC"/>
                        </svg>
                      </span>
                  </v-chip>
                  <v-card-text
                      class="pa-0"
                      :class="[$store.state.isMenuExpanded ? 'text-caption' : 'text-body-2']"
                  >
                      {{ $t('total-profit') }}
                  </v-card-text>
                </div>
                <div>
                  <v-select
                      :items="years"
                      :label="$t('date')"
                      dense
                      outlined
                      append-icon="mdi-chevron-down"
                      item-text="name"
                      item-value="value"
                      v-model="selectedYear"
                      style="width: 130px;"
                      :disabled="true"
                      :class="{ 'dltr' : !$vuetify.rtl}"
                      :style="{ 'direction' : !$vuetify.rtl ? 'rtl' : ''}"
                  >
                  </v-select>
                </div>
              </div>
              <v-card-text
                style="width: 175px;"
                class="pa-0 text-body-2"
              >
              {{ $t('your total profit in this interval') }}
              </v-card-text>
              <v-card-text
                v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview') && $store.state.admin == 'active'"
                class="pa-0 text-body-1"
              >
              {{ $numberFormat(totalProfit) }} {{ $store.state.currency.name }}
              </v-card-text>
              <div v-else>
                <img src="@/assets/dashboard/not-access(2).png" style="width: 100px;" />
                <v-card-text class="pa-0 text-caption">
                  {{ $t("you don't have access to this information") }}
                </v-card-text>
              </div>
          </v-container>
        </div>
      </v-container>
    </v-card>
</template>

<script>
import moment from 'moment-jalaali'

export default {
  data () {
    return {
      dashboardType: 'home',
      items: [
        {
          name: this.$t('one-week-ago'),
          value: '7days'
        },
        {
          name: this.$t('two-week-ago'),
          value: '14days'
        },
        {
          name: this.$t('one-month-ago'),
          value: '30days'
        }
      ],
      selectedSalesDate: '7days',
      selectedProfitDate: '7days',
      selectedYear: '1403',
      sumOfSells: null,
      today: null,
      hour: null,
      loading: false,
      sellList: [],
      totalProfit: null,
      years: [
        {
          name: this.$t('current-year'),
          value: '1403'
        }
      ],
      lineChartOptions: {
        chart: {
          type: 'line',
          toolbar: {
            show: false
          },
          fontFamily: 'IRANSans'
        },
        xaxis: {
          categories: [],
          axisBorder: {
            show: false // Hide the X-axis line
          },
          axisTicks: {
            show: false // Hide the ticks on the X-axis
          },
          labels: {
            show: true,
            rotate: 0, // Ensure labels are horizontal
            style: {
              fontSize: '10px'
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '10px'
            },
            offsetX: 0
            /*             formatter: (value) => {
              return value.toFixed(0) // Round to integer
            } */
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        markers: {
          size: 0,
          show: false
        },
        legend: {
          show: false
        }
      },
      // Data for the line chart (two datasets)
      lineChartSeries: [
        {
          name: 'Sales', // Label for the first dataset
          data: []
        }
      ]
    }
  },
  methods: {
    fetchList () {
      if (this.sellList == []) {
        this.loading = true
      }
      this.$axios.get(this.$endpoint + 'widgets', {
        params: {
          type: 'getSellChart',
          dateType: this.selectedSalesDate
        }
      })
        .then(r => {
          this.loading = false
          this.sellList = r.data
          this.lineChartOptions = {
            ...this.lineChartOptions,
            xaxis: {
              categories: this.sellList.map(item => item.key), // Dates on X-axis
              labels: {
                rotate: 0, // Keep labels horizontal
                style: {
                  fontSize: '10px'
                },
                show: true
              }
            },
            yaxis: {
              labels: {
                show: true,
                style: {
                  fontSize: '10px'
                },
                offsetX: this.$vuetify.rtl ? -60 : 0,
                formatter: (value) => {
                  /* return this.$numberFormat(value) */
                  return `${this.$numberFormat(value)} ${this.$store.state.currency.name}`
                }
              }
            }
          }
          this.lineChartSeries = [
            {
              name: this.$t('sell'),
              data: this.sellList.map(item => parseFloat(item.sell))
            }
          ]
          this.sumOfSells = this.sellList.reduce((sum, item) => sum + parseFloat(item.sell), 0)
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchProfit () {
      this.$axios.get(this.$endpoint + 'widgets', {
        params: {
          type: 'profit'
        }
      })
        .then(r => {
          this.totalProfit = r.data
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectDate (value, type) {
      if (type == 'sell') {
        this.selectedSalesDate = value
        this.fetchList()
      }
      if (type == 'profit') {
        this.selectedProfitDate = value
        this.fetchProfit()
      }
    },
    setToday () {
      var m = moment()
      if (this.$store.state.date_locale === 'fa,en') {
        // Get the Shamsi year, month, and day using moment-jalaali
        const shamsiYear = m.jYear() // Shamsi (Persian) year
        const shamsiMonth = m.jMonth() + 1 // Shamsi (Persian) month (starts from 1)
        const shamsiDay = m.jDate() // Day number in Shamsi calendar
        const hours = m.hour() // Get hours
        const minutes = m.minute() // Get minutes
        const weekday = m.format('jdddd').replace('j', '') // Persian weekday name (Fixing "jیکشنبه")

        // Get Persian month names
        const persianMonths = [
          'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
          'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
        ]

        // Format the date as 'weekday day month year' in Shamsi
        this.today = `${weekday} ${shamsiDay} ${persianMonths[shamsiMonth - 1]} ${shamsiYear}`
        this.hour = `${hours}:${minutes}`
      }
      if (this.$store.state.date_locale === 'en,fa') {
        this.today = m.format('dddd YYYY/MM/DD') // Includes the English weekday name
      }
    }

  },
  mounted () {
    this.fetchList()
    this.fetchProfit()
    this.setToday()
  }
}
</script>

<style scoped>
.wrapper {
  height: 160px;
}
.weather {
    background: linear-gradient(to left, #4C38D5, #6268FC);
    padding: 8px;
    color: #fff;
    width: 100%;
}
.v-card__text {
    width: auto;
}
.weather .v-card__text {
    color: #fff;
}
.position-relative {
    position: relative;
}
.weather-img {
  position: absolute;
  top: -29px;
  left: 3px;
  width: 80px;
}
.weather-img-exp {
  position: absolute;
  top: -25px;
  left: 3px;
  width: 70px;
}
.sales-label {
    background-color: #0066FF !important;
    padding: 0 !important;
    width: 27px;
    height: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.sales-label span {
    /* background-color: #8bbf9c; */
    background-color: #87afeb;
    border-radius: 4px;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.recieve-label {
    background-color: #137333 !important;
    padding: 0 !important;
    width: 27px;
    height: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.recieve-label span {
    border-radius: 4px;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
}
::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0 4px 0 0 !important;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 32px !important;
}
::v-deep .v-label.v-label {
    font-size: 11px !important;
}
::v-deep .v-icon.v-icon {
    font-size: 15px;
}
div[data-v-54a2d554] {
    min-height: unset !important;
}
::v-deep .apexcharts-canvas {
    top: -20px;
}
::v-deep .v-input .v-input__control .v-label.v-label--active  {
    right: 7px !important;
}
::v-deep .v-input.dltr .v-input__control .v-label.v-label--active  {
    left: 13px !important;
}
/* ::v-deep .apexcharts-text, .apexcharts-xaxis-label, .apexcharts-yaxis-label {
  font-family: 'IRANSans'!important;
} */
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
@media (max-width: 960px) {
  .wrapper {
    height: auto;
  }
  .wrapper .chart-row {
    flex-direction: column;
  }
  .wrapper .weather-wrapper {
    margin-top: 20px !important;
    width: 100% !important;
  }
  .wrapper .chart-row .flex-fill:nth-child(2) {
    margin-top: 16px;
  }
  .wrapper .chart-row .flex-fill:nth-child(2) .container {
    margin-right: 0 !important;
  }
}
</style>
